import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { migrateLegacyLocalStorage } from './lib/localStorageMigrations';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// The customer form is not part of the app: a relatie without an account opens it from a
// mail. Its own root keeps the staff session, interceptors and navigation out of it. Both are
// loaded on demand, so the app's modules never run on /formulier: react-toastify injects a
// <style> when it loads, which the page's CSP blocks.
if (window.location.pathname.replace(/\/+$/, '') === '/formulier') {
  import('./domains/customer-forms/pages/CustomerFormPage').then(({ default: CustomerFormPage }) =>
    root.render(<CustomerFormPage />));
} else {
  migrateLegacyLocalStorage();
  import('./app/App').then(({ default: App }) =>
    root.render(
      // Temporarily disable StrictMode due to React DnD compatibility issues
      // <React.StrictMode>
        <App />
      // </React.StrictMode>
    ));
}
